var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartner7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 162,
    viewBox: "0 0 168 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H144C157.255 0 168 10.7452 168 24V138C168 151.255 157.255 162 144 162H24C10.7452 162 0 151.255 0 138V24Z",
    fill: "#1A2541"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3886 35.7422V72.5401C79.3116 70.284 75.8896 67.7089 73.1364 64.8275C74.0199 64.8135 75.263 64.764 76.7535 64.6223C79.8196 64.3299 82.5509 62.0421 82.8297 58.6345C83.1084 55.2275 79.7636 53.3293 78.5373 52.6963C77.3109 52.0633 73.4647 51.187 73.1131 49.6293C72.7609 48.0717 75.4158 47.8283 75.9733 47.7311C76.5308 47.6338 82.3282 47.5849 82.3282 47.5849V43.5933H76.0846C73.632 43.5933 71.3461 44.3724 69.6744 45.6377C68.002 46.9036 67.2771 49.9217 68.6148 52.404C69.9531 54.8869 73.8547 55.7143 73.8547 55.7143C77.7571 56.8824 78.2978 58.9198 76.8357 59.9354C74.1895 61.7726 70.0681 59.5998 68.5129 58.6485C67.3732 56.6326 66.4882 54.5056 65.8616 52.2705C64.4846 47.3599 64.8121 43.2825 65.0596 41.5609C71.0412 41.3137 75.958 39.573 79.0991 38.1088C80.9513 37.2452 82.4017 36.386 83.3886 35.7422Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6504 40.2107C62.5965 40.4325 61.3571 45.7238 63.2857 52.7061C64.4174 56.802 66.4115 60.6334 69.212 64.0938C72.6995 68.4025 77.4497 72.1374 83.3301 75.1955L83.3884 75.226V78C79.3958 76.1005 57.3122 64.334 60.272 37.7335C60.272 37.7335 75.8231 37.2448 83.3884 30V32.7784L83.1118 33.0009C83.0921 33.0161 81.1344 34.5776 77.7888 36.1276C74.7286 37.5454 69.8372 39.2473 63.9182 39.3032L62.8673 39.3134L62.6504 40.2107Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 46.8438H84.613V48.0639H84.8896V46.8438Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 47.5859H85.1077V48.0632H86.4904V47.5859Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 47.5859H86.709V48.0632H88.0918V47.5859Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6928 47.5859H88.3101V48.0632H89.6928V47.5859Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3667 47.5859H89.9111V48.0632H91.3667V47.5859Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 47.5859H91.585V48.0632H92.9677V47.5859Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.186 47.5859C93.6853 47.5917 94.1554 47.7035 94.5688 47.8961V48.0626H93.186V47.5859Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8795 48.0625H94.7871V48.0078C94.8184 48.0256 94.849 48.044 94.8795 48.0625Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 45.4336H84.613V46.6531H84.8896V45.4336Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 63.7656H84.613V64.9852H84.8896V63.7656Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 64.8516H85.1077V64.9882H86.4904V64.8516Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 64.8516H86.709V64.9882H88.0918V64.8516Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6928 64.8516H88.3101V64.9882H89.6928V64.8516Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3667 63.7656V64.9852H89.9111V64.8485H90.2255V63.7656H91.3667Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 63.7656H91.585V64.9852H92.9677V63.7656Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5688 63.7656H93.186V64.9852H94.5688V63.7656Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M95.838 63.7656C95.4996 64.1514 95.1488 64.5321 94.7871 64.9076V63.7656H95.838Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 48.2539H84.613V49.4734H84.8896V48.2539Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 48.2539H85.1077V49.4734H86.4904V48.2539Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 48.2539H86.709V49.4734H88.0918V48.2539Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6928 48.2539H88.3101V49.4734H89.6928V48.2539Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3667 48.2539H89.9111V49.4734H91.3667V48.2539Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 48.2539H91.585V49.4734H92.9677V48.2539Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5688 48.2539H93.186V49.4734H94.5688V48.2539Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M96.052 49.4734H94.7871V48.2539H95.1568C95.5731 48.5761 95.8875 48.9962 96.052 49.4734Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 44.0195H84.613V45.2391H84.8896V44.0195Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 55.3047H84.613V56.5242H84.8896V55.3047Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 49.6641H84.613V50.8836H84.8896V49.6641Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 49.6641H85.1077V50.8836H86.4904V49.6641Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 49.6641H86.709V50.8836H88.0918V49.6641Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6928 49.6641H88.3101V50.8836H89.6928V49.6641Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3667 49.6641H89.9111V50.8836H91.3667V49.6641Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 49.6641H91.585V50.8836H92.9677V49.6641Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5688 49.6641H93.186V50.8836H94.5688V49.6641Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1808 50.2392C96.1808 50.3142 96.1772 50.3885 96.1699 50.4616C96.1561 50.6059 96.1291 50.747 96.0898 50.8836H94.7871V49.6641H96.108C96.1379 49.7797 96.159 49.8979 96.1699 50.0193C96.1772 50.0918 96.1808 50.1648 96.1808 50.2392Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 53.8945H84.613V55.1147H84.8896V53.8945Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 51.0742H84.613V52.2938H84.8896V51.0742Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 51.0742H85.1077V52.2938H86.4904V51.0742Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 51.0742H86.709V52.2938H88.0918V51.0742Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6928 51.0742H88.3101V52.2938H89.6928V51.0742Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3667 51.0742H89.9111V52.2938H91.3667V51.0742Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 51.0742H91.585V52.2938H92.9677V51.0742Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5688 51.0742H93.186V52.2938H94.5688V51.0742Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0265 51.0742C95.8431 51.5572 95.5054 51.9785 95.0637 52.2938H94.7871V51.0742H96.0265Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 41.1992H84.613V42.4188H84.8896V41.1992Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 41.1992H85.1077V42.4188H86.4904V41.1992Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 41.1992H86.709V42.4188H88.0918V41.1992Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6928 41.1992H88.3101V42.4188H89.6928V41.1992Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3667 41.1992H89.9111V42.4188H91.3667V41.1992Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 41.1992H91.585V42.4188H92.9677V41.1992Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5688 41.1992H93.186V42.4188H94.5688V41.1992Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1699 41.1992H94.7871V42.4188H96.1699V41.1992Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7712 41.1992H96.3884V42.4188H97.7712V41.1992Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1649 41.1992C99.258 41.2132 99.3512 41.2265 99.4451 41.2399V42.4188H97.9895V41.1992H99.1649Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6633 41.2695C100.117 41.3312 100.577 41.3846 101.046 41.429V42.4185H99.6633V41.2695Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M101.264 41.4531C101.719 41.4938 102.179 41.5256 102.647 41.5491V42.4223H101.264V41.4531Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M103.045 42.4216H102.865V41.5586C102.89 41.5599 102.916 41.5605 102.941 41.5618C102.976 41.8033 103.012 42.0918 103.045 42.4216Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M100.693 51.0742H101.046V52.2938H100.381C100.527 51.9017 100.632 51.4943 100.693 51.0742Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M102.446 51.0742C102.355 51.467 102.253 51.8661 102.14 52.2715C102.138 52.2791 102.136 52.2861 102.133 52.2938H101.264V51.0742H102.446Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8354 44.0195H96.1702V44.1384C96.0596 44.0964 95.9483 44.057 95.8354 44.0195Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3884 44.0195H97.7712V44.9614C97.344 44.6754 96.8811 44.4275 96.3884 44.2248V44.0195Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9895 44.0195H99.4451V45.2391H98.1583C98.103 45.1965 98.0463 45.1546 97.9895 45.1139V44.0195Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M101.046 44.0195H99.6633V45.2391H101.046V44.0195Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M102.647 44.0195H101.264V45.2391H102.647V44.0195Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M103.16 45.2391H102.865V44.0195H103.149C103.162 44.3996 103.166 44.8069 103.16 45.2391Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 66.5859H84.613V67.8055H84.8896V66.5859Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 66.5859H85.1077V67.8055H86.4904V66.5859Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 66.5859H86.709V67.8055H88.0918V66.5859Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6928 66.5859H88.3101V67.8055H89.6928V66.5859Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3667 66.5859H89.9111V67.8055H91.3667V66.5859Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 66.5859V66.6679C92.5413 67.0537 92.1017 67.4331 91.649 67.8055H91.585V66.5859H92.9677Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 65.1758H84.613V66.3953H84.8896V65.1758Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 65.1758H85.1077V66.3953H86.4904V65.1758Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 65.1758H86.709V66.3953H88.0918V65.1758Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6928 65.1758H88.3101V66.3953H89.6928V65.1758Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3667 65.1758H89.9111V66.3953H91.3667V65.1758Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 65.1758H91.585V66.3953H92.9677V65.1758Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M94.528 65.1758C94.122 65.5889 93.7013 65.995 93.2675 66.3953H93.186V65.1758H94.528Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 56.7148H84.613V57.9344H84.8896V56.7148Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 36.9688H84.613V38.1883H84.8896V36.9688Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 36.9688H85.1077V38.1883H86.4904V36.9688Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 37.7187V38.1896H86.709V36.9961C87.1355 37.2306 87.5969 37.4734 88.0918 37.7187Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0779 38.1916H88.3101V37.8281C88.5029 37.9222 88.7001 38.0162 88.9025 38.1109C88.96 38.1376 89.0196 38.1649 89.0779 38.1916Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 69.4062H84.613V70.6264H84.8896V69.4062Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 69.4062H85.1077V70.6264H86.4904V69.4062Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M86.709 69.4062H88.0918V70.4307C87.9935 70.4968 87.8945 70.5616 87.7956 70.6264H86.709V69.4062Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5713 69.4062C89.1601 69.7037 88.7394 69.9966 88.3101 70.2852V69.4062H89.5713Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 67.9961H84.613V69.2156H84.8896V67.9961Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 67.9961H85.1077V69.2156H86.4904V67.9961Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 67.9961H86.709V69.2156H88.0918V67.9961Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6928 67.9961H88.3101V69.2156H89.6928V67.9961Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4147 67.9961C91.3987 68.0088 91.3827 68.0222 91.3667 68.0349C90.8951 68.4162 90.4097 68.7911 89.9111 69.1584V67.9961H91.4147Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M84.613 72.2266H84.8896V72.3842C84.7979 72.4356 84.7055 72.4871 84.613 72.5386V72.2266Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1681 72.2266C85.1477 72.238 85.128 72.2494 85.1077 72.2609V72.2266H85.1681Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 70.8203H84.613V72.0399H84.8896V70.8203Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1077 70.8203H86.4904V71.452C86.1659 71.6503 85.8362 71.846 85.5014 72.0399H85.1077V70.8203Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5023 70.8203C87.241 70.9881 86.9768 71.154 86.709 71.3192V70.8203H87.5023Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 52.4844H84.613V53.7039H84.8896V52.4844Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 52.4844H85.1077V52.8917H86.4904V52.4844Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 52.4844H86.709V52.8917H88.0918V52.4844Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6928 52.4844H88.3101V52.8917H89.6928V52.4844Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3667 52.4844H89.9111V52.8917H91.3667V52.4844Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 52.4844H91.585V52.8917H92.9677V52.4844Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5688 52.4844V52.581C94.1554 52.7735 93.686 52.8854 93.186 52.8911V52.4844H94.5688Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4452 53.9609V55.1138H98.312C98.7378 54.7693 99.1191 54.3823 99.4452 53.9609Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M101.046 53.8945H99.6633V55.1147H101.046V53.8945Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M101.633 53.8945C101.516 54.232 101.393 54.5669 101.264 54.8993V53.8945H101.633Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M98.397 45.4336H99.445V46.5159C99.1408 46.1231 98.7892 45.7609 98.397 45.4336Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M101.046 45.4336H99.6633V46.6531H101.046V45.4336Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M102.647 45.4336H101.264V46.6531H102.647V45.4336Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M103.157 45.4336C103.149 45.8219 103.131 46.2293 103.103 46.6531H102.865V45.4336H103.157Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M100.406 48.2539H101.046V49.4734H100.701C100.647 49.0534 100.547 48.646 100.406 48.2539Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M102.647 48.2539H101.264V49.4734H102.647V48.2539Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M102.949 48.2539C102.924 48.4547 102.896 48.6587 102.865 48.8653V48.2539H102.949Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 58.125H84.613V59.3445H84.8896V58.125Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M100.306 52.4844H101.046V53.7039H99.6365C99.6459 53.6912 99.6547 53.6779 99.6634 53.6645C99.9203 53.2934 100.136 52.8987 100.306 52.4844Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M102.079 52.4844C101.96 52.8949 101.834 53.301 101.697 53.7039H101.264V52.4844H102.079Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6846 46.8438H101.046V48.0639H100.334C100.164 47.6356 99.9458 47.2276 99.6846 46.8438Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M102.647 46.8438H101.264V48.0639H102.647V46.8438Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M103.09 46.8438C103.061 47.2371 103.022 47.6445 102.972 48.0639H102.865V46.8438H103.09Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6125 35.7422C84.7013 35.8 84.793 35.8598 84.8891 35.9208V36.7793H84.6125V35.7422Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3209 36.7799H85.1077V36.0586C85.4672 36.2829 85.8726 36.5257 86.3209 36.7799Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 42.6133H84.613V43.8328H84.8896V42.6133Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 42.6133H85.1077V43.5951H86.4904V42.6133Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 42.6133H86.709V43.5951H88.0918V42.6133Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6928 42.6133H88.3101V43.5951H89.6928V42.6133Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3667 42.6133H89.9111V43.5951H91.3667V42.6133Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 42.6133H91.585V43.5951H92.9677V42.6133Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M93.186 42.6133H94.5688V43.7127C94.1205 43.6377 93.6584 43.5977 93.186 43.5958V42.6133Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7871 42.6133H96.1699V43.8328H95.1648C95.0404 43.803 94.9145 43.7756 94.7871 43.7515V42.6133Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7712 42.6133H96.3884V43.8328H97.7712V42.6133Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4451 42.6133H97.9895V43.8328H99.4451V42.6133Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M101.046 42.6133H99.6633V43.8328H101.046V42.6133Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M102.647 42.6133H101.264V43.8328H102.647V42.6133Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M103.143 43.8328H102.865V42.6133H103.063C103.096 42.9762 103.125 43.3835 103.143 43.8328Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 38.3789H84.613V39.5991H84.8896V38.3789Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 38.3789H85.1077V39.5991H86.4904V38.3789Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 38.3789H86.709V39.5991H88.0918V38.3789Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4992 38.3789C89.5633 38.4075 89.6273 38.4361 89.6928 38.4641V39.5991H88.3101V38.3789H89.4992Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9111 38.5586C90.3674 38.755 90.8536 38.9532 91.3667 39.149V39.5989H89.9111V38.5586Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6111 39.6017H91.585V39.2344C91.9161 39.3583 92.2582 39.481 92.6111 39.6017Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 39.793H84.613V41.0125H84.8896V39.793Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4904 39.793H85.1077V41.0125H86.4904V39.793Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0918 39.793H86.709V41.0125H88.0918V39.793Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6928 39.793H88.3101V41.0125H89.6928V39.793Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3667 39.793H89.9111V41.0125H91.3667V39.793Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 39.793H91.585V41.0125H92.9677V39.793Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M93.186 39.793C93.6314 39.9366 94.0928 40.077 94.5688 40.2118V41.0112H93.186V39.793Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7871 40.2695C95.2354 40.3935 95.6961 40.5117 96.1699 40.6229V41.0086H94.7871V40.2695Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3884 40.6758C96.8389 40.7787 97.2996 40.876 97.7712 40.9649V41.0107H96.3884V40.6758Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0179 41.0091H97.9895V41.0039C97.9992 41.0059 98.0082 41.0072 98.0179 41.0091Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M100.724 49.6641H101.046V50.8836H100.717C100.74 50.6713 100.752 50.4565 100.752 50.2392C100.752 50.0454 100.742 49.8534 100.724 49.6641Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M102.647 49.6641V50.135C102.599 50.3816 102.547 50.6313 102.49 50.8836H101.264V49.6641H102.647Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 62.3555H84.613V63.5756H84.8896V62.3555Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M91.367 62.3555H90.2258V63.5756H91.367V62.3555Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 62.3555H91.585V63.5756H92.9677V62.3555Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5688 62.3555H93.186V63.5756H94.5688V62.3555Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1699 62.3555V63.3818C96.1153 63.4466 96.06 63.5115 96.0047 63.5756H94.7871V62.3555H96.1699Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M97.007 62.3555C96.8054 62.6135 96.5995 62.869 96.3884 63.1225V62.3555H97.007Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 60.9453H84.613V62.1649H84.8896V60.9453Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8896 59.5352H84.613V60.7547H84.8896V59.5352Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M91.367 59.5352H90.2258V60.7547H91.367V59.5352Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 59.5352H91.585V60.7547H92.9677V59.5352Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5688 59.5352H93.186V60.7547H94.5688V59.5352Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1699 59.5352H94.7871V60.7547H96.1699V59.5352Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7712 59.5352H96.3884V60.7547H97.7712V59.5352Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9662 59.5352C98.7136 59.9463 98.4509 60.3531 98.1765 60.7547H97.9895V59.5352H98.9662Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M91.367 60.9453H90.2258V62.1649H91.367V60.9453Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 60.9453H91.585V62.1649H92.9677V60.9453Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5688 60.9453H93.186V62.1649H94.5688V60.9453Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1699 60.9453H94.7871V62.1649H96.1699V60.9453Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7712 60.9453V61.3336C97.5711 61.6132 97.3651 61.8903 97.154 62.1649H96.3884V60.9453H97.7712Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0463 60.9453C98.0273 60.9726 98.0084 60.9993 97.9895 61.026V60.9453H98.0463Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M91.367 58.125H90.2258V59.3445H91.367V58.125Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 58.125H91.585V59.3445H92.9677V58.125Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5688 58.125H93.186V59.3445H94.5688V58.125Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1699 58.125H94.7871V59.3445H96.1699V58.125Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7712 58.125H96.3884V59.3445H97.7712V58.125Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4451 58.125V58.7243C99.3272 58.9321 99.2056 59.1393 99.0819 59.3445H97.9895V58.125H99.4451Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7769 58.125C99.7397 58.1943 99.7019 58.2635 99.6633 58.3328V58.125H99.7769Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M91.367 56.8828H90.2258V57.9346H91.367V56.8828Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9677 56.8828H91.585V57.9346H92.9677V56.8828Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5688 56.7656V57.9343H93.186V56.8826C93.6584 56.88 94.1205 56.8406 94.5688 56.7656Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1699 56.7148V57.9344H94.7871V56.7263C94.8082 56.7231 94.8286 56.7193 94.8497 56.7148H96.1699Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7712 56.7148H96.3884V57.9344H97.7712V56.7148Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4451 56.7148H97.9895V57.9344H99.4451V56.7148Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M100.488 56.7148C100.294 57.1254 100.092 57.5321 99.8788 57.9344H99.6633V56.7148H100.488Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6143 56.5247C95.8035 56.4681 95.9883 56.4052 96.1703 56.3359V56.5247H95.6143Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7712 55.5117V56.5241H96.3884V56.2483C96.8804 56.0462 97.344 55.7983 97.7712 55.5117Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4451 55.3047V56.5242H97.9895V55.36C98.015 55.3422 98.0404 55.3231 98.0659 55.3047H99.4451Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M101.104 55.3047C101.085 55.3517 101.066 55.3987 101.046 55.4458C100.897 55.8086 100.74 56.1677 100.576 56.5242H99.6633V55.3047H101.104Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M96.751 66.398C97.1112 66.0243 97.4606 65.6456 97.799 65.2617V66.398H96.751Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4137 65.1797V66.3808C99.4086 66.3872 99.4035 66.3929 99.3984 66.3992H98.0171V65.1797H99.4137Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M100.371 65.1797C100.127 65.4974 99.8807 65.8088 99.6326 66.1145V65.1797H100.371Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3181 67.8077C95.6129 67.5325 95.9018 67.2542 96.1834 66.9727V67.8077H95.3181Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7989 66.5898V67.8094H96.4016V66.7551C96.4569 66.7004 96.5115 66.6451 96.5654 66.5898H97.7989Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M99.239 66.5898C98.8882 67.0086 98.5331 67.4154 98.175 67.8094H98.0171V66.5898H99.239Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0499 63.7656H99.4138V64.9852H98.0398C98.296 64.6903 98.5456 64.3922 98.7894 64.0916C98.8775 63.983 98.9641 63.8743 99.0499 63.7656Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M101.029 63.7656V64.2887C100.86 64.5238 100.689 64.7557 100.515 64.9852H99.6326V63.7656H101.029Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M101.401 63.7656C101.35 63.8381 101.299 63.9105 101.247 63.983V63.7656H101.401Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5684 68.4883V69.2159H93.7271C94.0123 68.9757 94.2933 68.7336 94.5684 68.4883Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1832 67.9961V69.2156H94.7866V68.2935C94.8965 68.195 95.0057 68.0959 95.1134 67.9961H96.1832Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7989 67.9961V68.2147C97.4794 68.5579 97.1578 68.8915 96.8354 69.2156H96.4016V67.9961H97.7989Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M100.238 62.1643C100.512 61.7729 100.775 61.3769 101.029 60.9766V62.1643H100.238Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M102.644 60.9492V61.8682C102.583 61.9692 102.521 62.069 102.458 62.1688H101.247V60.9492H102.644Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M103.189 60.9492C103.081 61.1367 102.972 61.3229 102.862 61.5072V60.9492H103.189Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M102.644 59.5352V60.7547H101.247V60.6282C101.471 60.2673 101.685 59.9025 101.891 59.5352H102.644Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M103.957 59.5352C103.743 59.9495 103.523 60.3556 103.297 60.7547H102.862V59.5352H103.957Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1982 63.5765C99.2703 63.4837 99.3423 63.3903 99.4137 63.2969V63.5765H99.1982Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M101.029 62.3555V63.5756H99.6326V63.0062C99.7934 62.7908 99.9506 62.5741 100.105 62.3555H101.029Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M102.338 62.3555C102.076 62.7711 101.807 63.1778 101.533 63.5756H101.247V62.3555H102.338Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9585 70.6263C92.2955 70.3708 92.6273 70.1128 92.9534 69.8516V70.6263H91.9585Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5682 69.4062V70.6264H93.1716V69.6757C93.2815 69.5861 93.3914 69.4965 93.4999 69.4062H94.5682Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1832 69.4062V69.8587C95.911 70.1212 95.6388 70.3767 95.3674 70.6264H94.7866V69.4062H96.1832Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6454 69.4062C96.5639 69.487 96.4831 69.567 96.4016 69.6465V69.4062H96.6454Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M92.198 36.9727H92.9534V37.2561C92.6943 37.1627 92.4425 37.068 92.198 36.9727Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1716 36.9727H94.5682V37.7982C94.0835 37.6488 93.6178 37.4938 93.1716 37.3343V36.9727Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7866 36.9727H96.1832V38.1922H95.9452C95.5486 38.0873 95.1622 37.978 94.7866 37.8649V36.9727Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7989 36.9727H96.4016V38.1922H97.7989V36.9727Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4137 36.9727H98.0171V38.1922H99.4137V36.9727Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M101.018 36.9727C101.021 36.9727 101.026 36.9739 101.029 36.9746V38.1922H99.6326V36.9727H101.018Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M101.247 37.0078C101.731 37.0904 102.198 37.1635 102.644 37.2283V38.188H101.247V37.0078Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M102.862 37.2617C103.356 37.3316 103.823 37.3914 104.259 37.4422V38.1902H102.862V37.2617Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M104.477 37.4688C104.995 37.5272 105.463 37.5736 105.874 37.6092V38.1913H104.477V37.4688Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M106.092 37.625C106.742 37.6797 107.222 37.707 107.489 37.7203V38.1881H106.092V37.625Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M107.777 38.1887H107.708V37.7305C107.721 37.7311 107.729 37.7311 107.729 37.7311C107.745 37.8843 107.761 38.0368 107.777 38.1887Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7847 73.4476C87.8931 73.3822 88.0008 73.3161 88.1078 73.25V73.4476H87.7847Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7237 72.2305V73.45H88.3264V73.1176C88.7944 72.8266 89.2536 72.5311 89.7041 72.2305H89.7237Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3385 72.2305H89.9419V73.45H91.3385V72.2305Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9535 72.2305V72.695C92.6267 72.9569 92.3029 73.2079 91.9826 73.45H91.5569V72.2305H92.9535Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5268 72.2305C93.4082 72.3283 93.2895 72.4249 93.1716 72.5196V72.2305H93.5268Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9878 72.0393C90.4477 71.7279 90.8982 71.4114 91.3385 71.0898V72.0393H89.9878Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9535 70.8203V72.0399H91.5569V70.9303C91.6064 70.894 91.6559 70.8572 91.7054 70.8203H92.9535Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5682 70.8203V71.3459C94.296 71.5842 94.026 71.8155 93.7568 72.0399H93.1716V70.8203H94.5682Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1585 70.8203C95.0348 70.9328 94.9103 71.0434 94.7866 71.1533V70.8203H95.1585Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8775 30.2472V31.1388H84.6125V30C84.6999 30.0833 84.7879 30.1659 84.8775 30.2472Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9356 31.1367H85.0964V30.4414C85.3679 30.681 85.6481 30.913 85.9356 31.1367Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8809 77.8711C84.8809 77.8711 84.8787 77.8724 84.8779 77.8724C84.7826 77.9188 84.6938 77.962 84.613 78.0001V77.8711H84.8809Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M102.638 58.125H102.644V59.3445H101.998C102.222 58.9416 102.434 58.5349 102.638 58.125Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M104.259 58.125V58.9365C104.192 59.0732 104.123 59.2092 104.055 59.3445H102.862V58.125H104.259Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M104.648 58.125C104.592 58.2464 104.535 58.3671 104.477 58.4872V58.125H104.648Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3069 74.8571C85.7079 74.6423 86.1031 74.4243 86.4932 74.2031V74.8571H85.3069Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1078 73.6406V74.8602H86.7112V74.0817C86.9652 73.9361 87.217 73.7893 87.4666 73.6406H88.1078Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7237 73.6406H88.3264V74.8602H89.7237V73.6406Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3385 73.6406V73.9285C90.8858 74.259 90.4441 74.5697 90.0154 74.8602H89.9419V73.6406H91.3385Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7286 73.6406C91.6711 73.6832 91.6137 73.7264 91.5569 73.7684V73.6406H91.7286Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6713 75.1952C84.7404 75.159 84.8095 75.1228 84.8779 75.0859V76.2693H84.613V75.2257L84.6713 75.1952Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M86.493 75.0469H85.0964V76.2664H86.493V75.0469Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1078 75.0469V76.0853C88.0066 76.1476 87.9076 76.2073 87.8094 76.2664H86.7112V75.0469H88.1078Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7332 75.0469C89.7332 75.0469 89.7267 75.0513 89.7237 75.0532C89.2369 75.3786 88.7696 75.6779 88.3264 75.9518V75.0469H89.7332Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8779 76.4609H84.613V77.6811H84.8779V76.4609Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M86.493 76.4609V77.0291C86.0265 77.2871 85.6132 77.5044 85.2638 77.6811H85.0964V76.4609H86.493Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4884 76.4609C87.217 76.6205 86.9572 76.7692 86.7112 76.9071V76.4609H87.4884Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8779 31.332H84.613V32.5522H84.8779V31.332Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1852 31.332C86.2871 31.4083 86.3897 31.4839 86.493 31.5583V32.5522H85.0964V31.332H86.1852Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0052 32.5498H86.7112V31.7109C87.1297 32.0045 87.562 32.2842 88.0052 32.5498Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7021 38.3828H97.7989V38.6275C97.4256 38.5506 97.0602 38.4686 96.7021 38.3828Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0171 38.3828H99.4137V38.9185C98.9377 38.8448 98.4719 38.7622 98.0171 38.672V38.3828Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6326 38.3828H101.029V39.1289C100.555 39.0793 100.089 39.0196 99.6326 38.9516V38.3828Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M101.247 38.3828H102.644V39.2579C102.171 39.2325 101.705 39.1963 101.247 39.1511V38.3828Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M102.862 38.3828H104.259V39.3062L104.083 39.3043C103.671 39.3005 103.264 39.2884 102.862 39.2693V38.3828Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M104.477 38.3828H105.874V39.603H105.204L105.134 39.3145L104.477 39.3081V38.3828Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M107.489 38.3828H106.092V39.603H107.489V38.3828Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M107.897 39.603H107.708V38.3828H107.796C107.836 38.7934 107.87 39.1994 107.897 39.603Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M105.535 41.2031H105.874V42.4227H105.682C105.637 41.9441 105.585 41.5349 105.535 41.2031Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M107.489 41.2031H106.092V42.4227H107.489V41.2031Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M108 42.4227H107.708V41.2031H107.978C107.991 41.613 107.999 42.0198 108 42.4227Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M105.249 39.793H105.874V41.0125H105.505C105.428 40.5371 105.362 40.2582 105.35 40.2111L105.249 39.793Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M107.489 39.793H106.092V41.0125H107.489V39.793Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M107.972 41.0125H107.708V39.793H107.909C107.936 40.2029 107.956 40.6096 107.972 41.0125Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M104.259 56.7148V57.9344H102.862V57.6662C103.012 57.3516 103.156 57.0339 103.295 56.7148H104.259Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M105.264 56.7148C105.094 57.1279 104.918 57.534 104.735 57.9344H104.477V56.7148H105.264Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M105.779 44.0234H105.874V45.243H105.789C105.795 44.8134 105.791 44.4066 105.779 44.0234Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M107.489 44.0234H106.092V45.243H107.489V44.0234Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M107.973 44.0234C107.958 44.434 107.937 44.8407 107.91 45.243H107.708V44.0234H107.973Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0488 35.5625H89.7235V35.8974C89.4913 35.7849 89.2664 35.6731 89.0488 35.5625Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9419 35.5625H91.3385V36.6257C90.9404 36.4579 90.5641 36.2914 90.2126 36.1287C90.1209 36.0862 90.0307 36.0442 89.9419 36.0016V35.5625Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5569 35.5625H92.9535V36.782H91.7177C91.6639 36.7598 91.61 36.7382 91.5569 36.7159V35.5625Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5682 35.5625H93.1716V36.782H94.5682V35.5625Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0217 35.5625C95.4103 35.6813 95.7982 35.7932 96.1832 35.8987V36.782H94.7866V35.5625H95.0217Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4016 35.957C96.8718 36.0841 97.3383 36.2023 97.7989 36.3116V36.7813H96.4016V35.957Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0171 36.3633C98.4901 36.4739 98.9566 36.5749 99.4137 36.6683V36.7814H98.0171V36.3633Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9812 36.7835H99.6326V36.7148C99.7497 36.7384 99.8655 36.7612 99.9812 36.7835Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M84.613 32.7383H84.8779V32.988L84.613 32.7745V32.7383Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0964 32.7383H86.493V33.9578H86.2601C85.71 33.6019 85.3162 33.3191 85.0964 33.1558V32.7383Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1078 32.7383H86.7112V33.9578H88.1078V32.7383Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3301 32.7383C88.7849 33.0007 89.25 33.2492 89.7237 33.485V33.9578H88.3264V32.7383H88.3301Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7192 33.9592H89.9419V33.5938C90.1988 33.7196 90.4579 33.841 90.7192 33.9592Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7112 34.1484H88.1078V35.0598C87.5816 34.7693 87.1144 34.4935 86.7112 34.2431V34.1484Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3264 34.1484H89.7237V35.368H88.6816C88.5608 35.3044 88.4421 35.2415 88.3264 35.1786V34.1484Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1507 34.1484C91.2133 34.1758 91.2759 34.2025 91.3385 34.2291V35.368H89.9419V34.1484H91.1507Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5569 34.3242C92.019 34.5168 92.4855 34.6985 92.9535 34.8701V35.3715H91.5569V34.3242Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4132 35.3712H93.1716V34.9492C93.585 35.0979 93.9991 35.2384 94.4132 35.3712Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M105.698 42.6133H105.874V43.8328H105.773C105.757 43.3911 105.731 42.9831 105.698 42.6133Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M107.489 42.6133H106.092V43.8328H107.489V42.6133Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M108 42.6133C107.999 43.0238 107.992 43.4305 107.98 43.8328H107.708V42.6133H108Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M103.938 55.1144C104.05 54.8119 104.157 54.5082 104.259 54.2031V55.1144H103.938Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M105.874 53.8945H104.477V55.1147H105.874V53.8945Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M106.289 53.8945C106.224 54.0973 106.159 54.2981 106.092 54.4983V53.8945H106.289Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M105.785 45.4336H105.873V46.6531H105.734C105.761 46.2305 105.777 45.8232 105.785 45.4336Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M107.489 45.4336H106.092V46.6531H107.489V45.4336Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M107.897 45.4336C107.867 45.8448 107.831 46.2509 107.788 46.6531H107.708V45.4336H107.897Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M104.775 52.4844H105.874V53.7039H104.419C104.439 53.6423 104.458 53.5806 104.477 53.519C104.56 53.2489 104.64 52.9782 104.715 52.7055C104.735 52.6318 104.755 52.5581 104.775 52.4844Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M106.703 52.4844C106.591 52.8962 106.473 53.3029 106.349 53.7039H106.092V52.4844H106.703Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M103.868 55.3047H104.259V56.5242H103.377C103.55 56.1207 103.714 55.714 103.868 55.3047Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M105.81 55.3047C105.66 55.7171 105.504 56.1239 105.342 56.5242H104.477V55.3047H105.81Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M105.117 51.0742H105.874V52.2938H104.825C104.933 51.8807 105.03 51.474 105.117 51.0742Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M107.057 51.0742C106.962 51.486 106.862 51.8928 106.755 52.2938H106.092V51.0742H107.057Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M105.721 46.8438H105.874V48.0639H105.611C105.658 47.6445 105.695 47.2378 105.721 46.8438Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M107.489 46.8438H106.092V48.0639H107.489V46.8438Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M107.768 46.8438C107.749 47.0172 107.729 47.1895 107.708 47.3611V46.8438H107.768Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M105.589 48.2539H105.874V49.4734H105.419C105.486 49.0566 105.542 48.6498 105.589 48.2539Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M107.489 48.2539V48.8754C107.456 49.0756 107.422 49.2752 107.385 49.4734H106.092V48.2539H107.489Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M105.387 49.6641H105.873V50.8836H105.157C105.245 50.4693 105.321 50.0625 105.387 49.6641Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M107.351 49.6641C107.274 50.0759 107.19 50.482 107.1 50.8836H106.092V49.6641H107.351Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4159 68C91.3995 68.013 91.3831 68.0267 91.3667 68.0397V68H91.4159Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1811 50.2394C96.1811 50.3144 96.1774 50.3888 96.1702 50.4618V50.0195C96.1774 50.092 96.1811 50.1651 96.1811 50.2394Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6365 53.7045C99.6462 53.6914 99.6551 53.6777 99.6641 53.6641V53.7045H99.6365Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M101.104 55.3047C101.085 55.3517 101.066 55.3987 101.046 55.4458V55.3047H101.104Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M89.732 75.0508C89.732 75.0508 89.7257 75.0551 89.7229 75.0569V75.0508H89.732Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M104.419 53.7045C104.439 53.6428 104.458 53.5812 104.476 53.5195V53.7045H104.419Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3641 124.14C37.3907 124.14 36.5107 123.973 35.7241 123.64C34.9507 123.307 34.3374 122.827 33.8841 122.2C33.4307 121.573 33.1974 120.833 33.1841 119.98H36.1841C36.2241 120.553 36.4241 121.007 36.7841 121.34C37.1574 121.673 37.6641 121.84 38.3041 121.84C38.9574 121.84 39.4707 121.687 39.8441 121.38C40.2174 121.06 40.4041 120.647 40.4041 120.14C40.4041 119.727 40.2774 119.387 40.0241 119.12C39.7707 118.853 39.4507 118.647 39.0641 118.5C38.6907 118.34 38.1707 118.167 37.5041 117.98C36.5974 117.713 35.8574 117.453 35.2841 117.2C34.7241 116.933 34.2374 116.54 33.8241 116.02C33.4241 115.487 33.2241 114.78 33.2241 113.9C33.2241 113.073 33.4307 112.353 33.8441 111.74C34.2574 111.127 34.8374 110.66 35.5841 110.34C36.3307 110.007 37.1841 109.84 38.1441 109.84C39.5841 109.84 40.7507 110.193 41.6441 110.9C42.5507 111.593 43.0507 112.567 43.1441 113.82H40.0641C40.0374 113.34 39.8307 112.947 39.4441 112.64C39.0707 112.32 38.5707 112.16 37.9441 112.16C37.3974 112.16 36.9574 112.3 36.6241 112.58C36.3041 112.86 36.1441 113.267 36.1441 113.8C36.1441 114.173 36.2641 114.487 36.5041 114.74C36.7574 114.98 37.0641 115.18 37.4241 115.34C37.7974 115.487 38.3174 115.66 38.9841 115.86C39.8907 116.127 40.6307 116.393 41.2041 116.66C41.7774 116.927 42.2707 117.327 42.6841 117.86C43.0974 118.393 43.3041 119.093 43.3041 119.96C43.3041 120.707 43.1107 121.4 42.7241 122.04C42.3374 122.68 41.7707 123.193 41.0241 123.58C40.2774 123.953 39.3907 124.14 38.3641 124.14ZM50.6516 124.18C49.5849 124.18 48.6249 123.947 47.7716 123.48C46.9182 123 46.2449 122.327 45.7516 121.46C45.2716 120.593 45.0316 119.593 45.0316 118.46C45.0316 117.327 45.2782 116.327 45.7716 115.46C46.2782 114.593 46.9649 113.927 47.8316 113.46C48.6982 112.98 49.6649 112.74 50.7316 112.74C51.7982 112.74 52.7649 112.98 53.6316 113.46C54.4982 113.927 55.1782 114.593 55.6716 115.46C56.1782 116.327 56.4316 117.327 56.4316 118.46C56.4316 119.593 56.1716 120.593 55.6516 121.46C55.1449 122.327 54.4516 123 53.5716 123.48C52.7049 123.947 51.7316 124.18 50.6516 124.18ZM50.6516 121.74C51.1582 121.74 51.6316 121.62 52.0716 121.38C52.5249 121.127 52.8849 120.753 53.1516 120.26C53.4182 119.767 53.5516 119.167 53.5516 118.46C53.5516 117.407 53.2716 116.6 52.7116 116.04C52.1649 115.467 51.4916 115.18 50.6916 115.18C49.8916 115.18 49.2182 115.467 48.6716 116.04C48.1382 116.6 47.8716 117.407 47.8716 118.46C47.8716 119.513 48.1316 120.327 48.6516 120.9C49.1849 121.46 49.8516 121.74 50.6516 121.74ZM61.2855 109.2V124H58.4855V109.2H61.2855ZM65.4719 111.6C64.9785 111.6 64.5652 111.447 64.2319 111.14C63.9119 110.82 63.7519 110.427 63.7519 109.96C63.7519 109.493 63.9119 109.107 64.2319 108.8C64.5652 108.48 64.9785 108.32 65.4719 108.32C65.9652 108.32 66.3719 108.48 66.6919 108.8C67.0252 109.107 67.1919 109.493 67.1919 109.96C67.1919 110.427 67.0252 110.82 66.6919 111.14C66.3719 111.447 65.9652 111.6 65.4719 111.6ZM66.8519 112.92V124H64.0519V112.92H66.8519ZM68.8983 118.42C68.8983 117.3 69.1183 116.307 69.5583 115.44C70.0116 114.573 70.6249 113.907 71.3983 113.44C72.1716 112.973 73.0316 112.74 73.9783 112.74C74.6983 112.74 75.3849 112.9 76.0383 113.22C76.6916 113.527 77.2116 113.94 77.5983 114.46V109.2H80.4383V124H77.5983V122.36C77.2516 122.907 76.7649 123.347 76.1383 123.68C75.5116 124.013 74.7849 124.18 73.9583 124.18C73.0249 124.18 72.1716 123.94 71.3983 123.46C70.6249 122.98 70.0116 122.307 69.5583 121.44C69.1183 120.56 68.8983 119.553 68.8983 118.42ZM77.6183 118.46C77.6183 117.78 77.4849 117.2 77.2183 116.72C76.9516 116.227 76.5916 115.853 76.1383 115.6C75.6849 115.333 75.1983 115.2 74.6783 115.2C74.1583 115.2 73.6783 115.327 73.2383 115.58C72.7983 115.833 72.4383 116.207 72.1583 116.7C71.8916 117.18 71.7583 117.753 71.7583 118.42C71.7583 119.087 71.8916 119.673 72.1583 120.18C72.4383 120.673 72.7983 121.053 73.2383 121.32C73.6916 121.587 74.1716 121.72 74.6783 121.72C75.1983 121.72 75.6849 121.593 76.1383 121.34C76.5916 121.073 76.9516 120.7 77.2183 120.22C77.4849 119.727 77.6183 119.14 77.6183 118.46ZM85.973 114.52C86.333 114.013 86.8263 113.593 87.453 113.26C88.093 112.913 88.8196 112.74 89.633 112.74C90.5796 112.74 91.433 112.973 92.193 113.44C92.9663 113.907 93.573 114.573 94.013 115.44C94.4663 116.293 94.693 117.287 94.693 118.42C94.693 119.553 94.4663 120.56 94.013 121.44C93.573 122.307 92.9663 122.98 92.193 123.46C91.433 123.94 90.5796 124.18 89.633 124.18C88.8196 124.18 88.0996 124.013 87.473 123.68C86.8596 123.347 86.3596 122.927 85.973 122.42V129.28H83.173V112.92H85.973V114.52ZM91.833 118.42C91.833 117.753 91.693 117.18 91.413 116.7C91.1463 116.207 90.7863 115.833 90.333 115.58C89.893 115.327 89.413 115.2 88.893 115.2C88.3863 115.2 87.9063 115.333 87.453 115.6C87.013 115.853 86.653 116.227 86.373 116.72C86.1063 117.213 85.973 117.793 85.973 118.46C85.973 119.127 86.1063 119.707 86.373 120.2C86.653 120.693 87.013 121.073 87.453 121.34C87.9063 121.593 88.3863 121.72 88.893 121.72C89.413 121.72 89.893 121.587 90.333 121.32C90.7863 121.053 91.1463 120.673 91.413 120.18C91.693 119.687 91.833 119.1 91.833 118.42ZM99.5277 114.64C99.8877 114.053 100.354 113.593 100.928 113.26C101.514 112.927 102.181 112.76 102.928 112.76V115.7H102.188C101.308 115.7 100.641 115.907 100.188 116.32C99.7477 116.733 99.5277 117.453 99.5277 118.48V124H96.7277V112.92H99.5277V114.64ZM109.734 124.18C108.667 124.18 107.707 123.947 106.854 123.48C106 123 105.327 122.327 104.834 121.46C104.354 120.593 104.114 119.593 104.114 118.46C104.114 117.327 104.36 116.327 104.854 115.46C105.36 114.593 106.047 113.927 106.914 113.46C107.78 112.98 108.747 112.74 109.814 112.74C110.88 112.74 111.847 112.98 112.714 113.46C113.58 113.927 114.26 114.593 114.754 115.46C115.26 116.327 115.514 117.327 115.514 118.46C115.514 119.593 115.254 120.593 114.734 121.46C114.227 122.327 113.534 123 112.654 123.48C111.787 123.947 110.814 124.18 109.734 124.18ZM109.734 121.74C110.24 121.74 110.714 121.62 111.154 121.38C111.607 121.127 111.967 120.753 112.234 120.26C112.5 119.767 112.634 119.167 112.634 118.46C112.634 117.407 112.354 116.6 111.794 116.04C111.247 115.467 110.574 115.18 109.774 115.18C108.974 115.18 108.3 115.467 107.754 116.04C107.22 116.6 106.954 117.407 106.954 118.46C106.954 119.513 107.214 120.327 107.734 120.9C108.267 121.46 108.934 121.74 109.734 121.74ZM122.488 124.18C121.421 124.18 120.461 123.947 119.608 123.48C118.754 123 118.081 122.327 117.588 121.46C117.108 120.593 116.868 119.593 116.868 118.46C116.868 117.327 117.114 116.327 117.608 115.46C118.114 114.593 118.801 113.927 119.668 113.46C120.534 112.98 121.501 112.74 122.568 112.74C123.634 112.74 124.601 112.98 125.468 113.46C126.334 113.927 127.014 114.593 127.508 115.46C128.014 116.327 128.268 117.327 128.268 118.46C128.268 119.593 128.008 120.593 127.487 121.46C126.981 122.327 126.288 123 125.408 123.48C124.541 123.947 123.568 124.18 122.488 124.18ZM122.488 121.74C122.994 121.74 123.468 121.62 123.908 121.38C124.361 121.127 124.721 120.753 124.988 120.26C125.254 119.767 125.388 119.167 125.388 118.46C125.388 117.407 125.108 116.6 124.548 116.04C124.001 115.467 123.328 115.18 122.528 115.18C121.728 115.18 121.054 115.467 120.508 116.04C119.974 116.6 119.708 117.407 119.708 118.46C119.708 119.513 119.968 120.327 120.488 120.9C121.021 121.46 121.688 121.74 122.488 121.74ZM135.401 115.22H133.461V124H130.621V115.22H129.361V112.92H130.621V112.36C130.621 111 131.008 110 131.781 109.36C132.555 108.72 133.721 108.42 135.281 108.46V110.82C134.601 110.807 134.128 110.92 133.861 111.16C133.595 111.4 133.461 111.833 133.461 112.46V112.92H135.401V115.22Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner7);
export default __webpack_public_path__ + "static/media/partner7.1feece0ea43ad30ebd6656e92f9d69b3.svg";
export { ForwardRef as ReactComponent };